import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * @param {function} [onClose] - Called with no argument when the
 *   close button is clicked
 * @param {function} [content] - Any renderable content
 */
export default class ClosingWrapperWidget extends Widget {
	constructor({ onClose = () => {}, content }) {
		super(...arguments);

		this._onClose = onClose;
		this._content = content;
	}

	renderContentOn(html) {
		html.div(
			{
				class: "ClosingWrapperWidget",
			},
			this._renderCloseButtonOn.bind(this),
			this._content,
		);
	}

	_renderCloseButtonOn(html) {
		html.div(
			{
				class: "close icon",
				"data-test": "close",
				click: () => this._onClose(),
			},
			"×",
		);
	}
}
